import { render, staticRenderFns } from "./ArrowSVG.vue?vue&type=template&id=0af0ba0a&scoped=true"
var script = {}
import style0 from "./ArrowSVG.vue?vue&type=style&index=0&id=0af0ba0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af0ba0a",
  null
  
)

export default component.exports